import { modelOptions, post, prop, PropType } from "@typegoose/typegoose";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";

const SCHEMA_KEY = "LoggerSchedule" as const;

/** A single valve open/close transition event within a schedule. */
class ValveEvent {
    @prop({ type: () => Date, required: true })
    public date!: Date;

    @prop({ type: () => Boolean, required: true })
    public open!: boolean;
}

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<LoggerSchedule>>(...addSchemaKeyHook(SCHEMA_KEY))
export class LoggerSchedule extends SchemaBase<LoggerSchedule> {
    static readonly schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => Date, required: false })
    public referenceTime?: Date;

    @prop({ type: () => Boolean, required: false })
    public startOpen?: boolean;

    @prop({ type: () => ValveEvent, required: false }, PropType.ARRAY)
    public valveEvents?: ValveEvent[];

    static getters = {} as const satisfies Record<string, (self: LoggerSchedule) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<LoggerSchedule>) {
        super(properties);
        Object.assign(this, properties);
    }
}
